import { useEffect } from "react";

// Declare the window interface extension
declare global {
  interface Window {
    tb: any; // Replace 'any' with proper Threebox type if available
  }
}

// const modelObj = {
//     id: "model-1",
//     obj: "https://docs.mapbox.com/mapbox-gl-js/assets/metlife-building.gltf",
//     type: "gltf",
//     coordinates: [6.933145523071289, 50.919368743896484],
//     rotation: 90,
//     scale:1
//   };

const use3d = (map: any, modelObj: any) => {
  useEffect(() => {
    if (!map?._loaded) return;
    if (!modelObj) return;

    // Lazy load Threebox
    import("threebox-plugin").then(({ Threebox }) => {
      console.log(modelObj.coordinates, modelObj);
      window.tb = new Threebox(map, map.getCanvas().getContext("webgl"), {
        defaultLights: true,
        enableSelectingObjects: true,
        enableDraggingObjects: true,
        enableRotatingObjects: true,
        //   realSunlight: true,
        //   sky: true,
        enableTooltips: true, // enable default tooltips on fill-extrusion and 3D models

        // enableHelpTooltips: true,
        // enableTooltips: false,
      });

      map.addLayer({
        id: modelObj.id,
        type: "custom",
        renderingMode: "3d",
        onAdd(map, _gl) {
          console.log(modelObj);
          const options = {
            obj: modelObj?.obj,
            type: modelObj?.type || "fbx",
            scale: modelObj?.scale || 0.1,
            units: "meters",
            rotation: { x: 90, y: modelObj?.rotation || 0, z: 0 },
          };

          // const options = {
          //   type: "fbx",
          //   obj: modelUrl,
          //   scale: 1,
          //   units: "meters",
          //   rotation: { x: 90, y: 0, z: 0.1 }, // default rotation,
          //   anchor: "center",
          //   //   labelText: model.labelText || "",
          //   //   id: model.id,
          // };

          window?.tb.loadObj(options, (model) => {
            console.log(model);
            //   newModel.castShadow = true;
            //   window?.tb.lights.dirLight.target = newModel;
            //   if (model.labelText) {
            //     newModel.addLabel(createLabel(model.id, model.labelText), true);
            //   }

            //   makeTooltipInteractive(newModel, setOpenContextPanel, setSwipedUp);
            const positionedModel = model.setCoords(modelObj.coordinates);
            window?.tb.add(positionedModel);
          });
        },
        render(gl, matrix) {
          const nextNoon = new Date();
          if (nextNoon.getHours() >= 12)
            nextNoon.setDate(nextNoon.getDate() + 1);
          nextNoon.setHours(12, 0, 0, 0);

          // window?.tb?.setSunlight(nextNoon, [50.9, 6.5]);

          window?.tb?.update(); // update Threebox scene
        },
      });
    });

    // Cleanup function
    return () => {
      if (window.tb) {
        // Clean up Threebox instance if needed
        window.tb = null;
      }
    };
  }, [
    map,
    map?._loaded,
    map?.addLayer,
    map?.getCanvas,
    modelObj,
    modelObj?.coordinates,
    modelObj?.id,
    modelObj?.obj,
    modelObj?.rotation,
    modelObj?.scale,
    modelObj?.type,
  ]);
};

export default use3d;
